export default __webpack_public_path__ + "static/media/ic-coin.99084e95.svg";